<script>
  import { onMount } from "svelte";

  let palettes = [
    {"center": "#E6CC66", "light": "#EBDDBF", "medium": "#CDD4BD", "dark": "#9EB6B2", "bg": "#364F61"},
    {"center": "#eccc8f", "light": "#f2c5e0", "medium": "#ec8fd0", "dark": "#d43790", "bg": "#ffcedd"},
    {"center": "#e1c97f", "light": "#86c5f9", "medium": "#2196f3", "dark": "#085391", "bg": "#c0e1fc"},
  ]
  let svg;

  let width = 0;
  let height = 0;

  function choose(choices) {
    var index = Math.floor(Math.random() * choices.length);
    return choices[index];
  }

  let flowers = []
  const light_colors = ["#EBDDBF", "#FFC0CB"];

  function refresh() {
    let palette = choose(palettes)
    svg.style.setProperty('--light', palette['light']);
    svg.style.setProperty('--medium', palette['medium']);
    svg.style.setProperty('--dark', palette['dark']);
    svg.style.setProperty('--center-color', palette['center']);
    svg.style.setProperty('background-color', palette['bg']);

    let classes = ["light", "dark", "medium"]

    flowers = Array(15);
    for (let i=0; i < flowers.length; i++) {
      let x = Math.floor(Math.random() * width);
      let y = Math.floor(Math.random() * height);
      let rot = Math.floor(Math.random() * (360 / 16));
      let css_class = choose(classes);
      flowers[i] = {"x": x, "y": y, "class": css_class, "rot": rot}
    }
  }

  function handleKey(e) {
    if (e.code == "Space") {
      refresh();
    }
  }

  onMount(() => {
    refresh();

    document.addEventListener('keydown', handleKey);
  })

</script>

<div class="continer" on:click={refresh} bind:offsetWidth="{width}" bind:offsetHeight="{height}">
  <svg bind:this="{svg}" viewBox="0 0 {width} {height}" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="1.5">
    <symbol id="flower" viewBox="0 0 768 768">
      <path transform="translate(15, 15)" d="M628 628s43-13 62-42c19-28 13-70 13-70s34-29 41-62-15-70-15-70 21-40 14-73c-6-34-40-59-40-59s4-45-15-73-60-39-60-39-13-43-42-62c-28-19-70-13-70-13s-29-34-62-41-70 15-70 15-40-21-73-14c-34 6-59 40-59 40s-45-4-73 15-39 60-39 60-43 13-62 42c-19 28-13 70-13 70s-34 29-41 62 15 70 15 70-21 40-14 73c6 34 40 59 40 59s-4 45 15 73 60 39 60 39 13 43 42 62c28 19 70 13 70 13s29 34 62 41 70-15 70-15 40 21 73 14c34-6 59-40 59-40s45 4 73-15 39-60 39-60" fill="#ebddbf" style="fill: var(--petal-color)" stroke="none"/>
      <g fill="none" stroke="#000" stroke-width="4">
        <path d="M384 384V37s-40-19-73-12c-34 6-60 39-60 39l133 320"/>
        <path d="M384 384L251 64s-44-3-72 16-40 59-40 59l245 245"/>
        <path d="M384 384L139 139s-42 14-61 43c-19 28-14 69-14 69l320 133"/>
        <path d="M384 384L64 251s-33 30-40 63 13 70 13 70h347M384 384H37s-19 40-12 73c6 34 39 60 39 60l320-133"/>
        <path d="M384 384L64 517s-3 44 16 72 59 40 59 40l245-245"/>
        <path d="M384 384L139 629s14 42 43 61c28 19 69 14 69 14l133-320"/>
        <path d="M384 384L251 704s30 33 63 40 70-13 70-13V384M384 384v347s40 19 73 12c34-6 60-39 60-39L384 384"/>
        <path d="M384 384l133 320s44 3 72-16 40-59 40-59L384 384"/>
        <path d="M384 384l245 245s42-14 61-43c19-28 14-69 14-69L384 384"/>
        <path d="M384 384l320 133s33-30 40-63-13-70-13-70H384M384 384h347s19-40 12-73c-6-34-39-60-39-60L384 384"/>
        <path d="M384 384l320-133s3-44-16-72-59-40-59-40L384 384"/>
        <path d="M384 384l245-245s-14-42-43-61c-28-19-69-14-69-14L384 384"/>
        <path d="M384 384L517 64s-30-33-63-40-70 13-70 13v347"/>
      </g>
      <circle cx="384" cy="384" r="56.2" fill="#e6cc66" style="fill: var(--center-color)"/>

      <path d="M383 342l-8-5 11 35-3-30zM365 347l-9-1 24 26-15-25zM351 359l-9 3 34 13-25-16zM343 376l-7 6 37-2-30-4zM343 394l-3 9 32-18-29 9zM352 411l1 9 21-30-22 21zM367 422l5 8 5-36-10 28zM385 426l8 5-11-35 3 30zM403 421l9 1-24-26 15 25zM417 409l9-3-34-13 25 16zM425 392l7-6-37 2 30 4zM425 374l3-9-32 18 29-9zM416 357l-1-9-21 30 22-21zM401 346l-5-8-5 36 10-28z" fill="#000" opacity="0.3"/>

    </symbol>
  
    {#each flowers as f, i}
      <use xlink:href="#flower" height="200" width="200" transform="rotate({f.rot} 100 100) translate({f.x}, {f.y})" class="{f.class}" />
    {/each}
  
    <style>

      .light {
        --petal-color: var(--light);
      }
      .dark {
        --petal-color: var(--dark);;
      }
      .medium {
        --petal-color: var(--medium);;
      }
    </style>
  </svg>
</div>

<style>
  .continer {
    width: 100%;
    height: 100%;
  }
</style>


